import React from "react";

import { GameInformationConfigurationsDataType } from "../../../../models/forms";
import { LocalPlayerModes, OnlinePlayerModes } from "../../../../models/playerModes";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyIdXboxConfigurationsProps = {
  dataInForm: GameInformationConfigurationsDataType;
};

const IdXboxConfigurationsConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "localPlayerModes",
    {
      mapper: (
        data: GameInformationConfigurationsDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.localPlayerModes
          .filter(value => value.selected)
          .map(element => {
            const localizedPlayerMode = localizedStrings.get(element.playerMode);
            if (element.playerMode === LocalPlayerModes.singleMultiplayer) {
              return localizedPlayerMode;
            }
            return `${localizedPlayerMode}: ${element.playersPerConsole} ${localizedStrings.get(
              "playersPerConsole"
            )}`;
          }),
    },
  ],
  [
    "onlinePlayerModes",
    {
      mapper: (
        data: GameInformationConfigurationsDataType,
        localizedStrings: Map<string, string>
      ) =>
        data.onlinePlayerModes
          .filter(value => value.selected)
          .map(element => {
            const localizedPlayerMode = localizedStrings.get(element.playerMode);
            if (element.playerMode === OnlinePlayerModes.onlineSinglePlayer) {
              return localizedPlayerMode;
            }
            return `${localizedPlayerMode}: ${element.playersPerConsole} ${localizedStrings.get(
              "playersPerConsole"
            )}`;
          }),
    },
  ],
  [
    "crossPlay",
    {
      mapper: (
        data: GameInformationConfigurationsDataType,
        localizedStrings: Map<string, string>
      ) => data.crossPlay.map(element => localizedStrings.get(element) ?? ""),
    },
  ],
]);

export const ReadOnlyIdXboxConfigurations = ({ dataInForm }: ReadOnlyIdXboxConfigurationsProps) => {
  const extraStringsToLocalize = [
    "playerModes",
    "singleMultiplayer",
    "multiplayer",
    "couchCoOp",
    "onlineSinglePlayer",
    "onlineMultiplayer",
    "onlineCoOp",
    "compatibility",
    "windowsStoreVersions",
    "win32Versions",
    "playStationVersions",
    "nintendoSwitchVersions",
    "otherVersions",
    "aaaNumberOfPlayerPerServer",
    "playersPerConsole",
  ];
  return (
    <ReadOnlyForm
      formConfig={IdXboxConfigurationsConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
